import zod from 'zod';
import { MANDATORY_FIELD } from '../../config/zodConfig';

export const IntegrationFormSchema = zod.object({
  isActive: zod.boolean(),
  name: zod.string({ required_error: MANDATORY_FIELD }).min(1, MANDATORY_FIELD),
  description: zod.string().optional(),
});
